import { i18n } from '@/i18n';

export default function(value: any): string {
  const wDays = [
    i18n.t('Monday').toString(),
    i18n.t('Tuesday').toString(),
    i18n.t('Wednesday').toString(),
    i18n.t('Thursday').toString(),
    i18n.t('Friday').toString(),
    i18n.t('Saturday').toString(),
    i18n.t('Sunday').toString(),
  ];
  return wDays[parseInt(value, 10) - 1];
}
